<template>
<div class="calendar-week" :data-monday="settimana.monday">
<div
v-for="day in settimana.days"
class="calendar-day"
:key="'day-'+day.date"
:data-day="day.date"
:class="classDay(day.date)" >
<div class="calendar-table__cell" >
<div class="day-container"
@click="openImpegno(day.date)" >
<h4 class="day-number">{{formatCalendarDay(day.date)}}</h4>
<v-spacer></v-spacer>
<div class="day-badges">
</div>

<div class="day-impegno" v-if="impegnoDelGiorno(day.date)" @click.stop="openImpegno(day.date)" >
<i :class="iconImpegno(day.date)" />
</div>
</div>
<div class="day-misurazioni">
<msp-misurazioni
        :misurazioni="perGiorno.misurazioni[day.date] || nessuno"
        :parametri="parametri"
        >
        </msp-misurazioni>
</div>
<flag-attivita class="attivita"
v-for = "item in perGiorno.attivita[day.date]"
:key = "'attivita-'+item.id"
:item="item"
@open-modal="$emit('open-modal', item)"
>
</flag-attivita>
<div class="day-content"
v-for = "item in perGiorno.items[day.date]"
:key="'content-'+item.id">
<msp-allenamento-item
v-if="item.type==='allenamento'"
:allenamento="item.data"
@click="$emit('open-modal', item)"
@open-attivita="$emit('open-attivita', $event)"
@open-chat-calendario="$emit('open-chat-calendario', $event)"
></msp-allenamento-item>
<msp-gara-item
v-else-if="item.type==='gara'"
:gara="item.data"
@click="$emit('open-modal', item)"
@open-chat-calendario="$emit('open-chat-calendario', $event)"
></msp-gara-item>
<msp-test-item
v-else-if="item.type==='test'"
:test="item.data"
@click="$emit('open-modal', item)"
></msp-test-item>
<msp-risultato-item
v-else-if="item.type==='risultato'"
:risultato="item.data"
@click="$emit('open-modal', item)"
></msp-risultato-item>
</div>

</div>
</div>
</div>
</template>

<script>
/** Una settimana del calendario mobile (pages/calendario/Calendario.vue).
 * Riceve dal calendario solo i dati della sua settimana (v. settimaneVista): se la
 * settimana non cambia riceve gli stessi oggetti e Vue non la ridisegna. Non deve
 * leggere eventi, attività o misurazioni dallo store, che crescono a ogni caricamento
 * e la farebbero ridisegnare insieme a tutte le altre.
 */
import _cal from "@src/js/vue/mixins/calendario.js";
import MspAllenamentoItem from "./MspAllenamentoItem.vue";
import MspGaraItem from "./MspGaraItem.vue";
import MspMisurazioni from "./MspMisurazioni.vue";
import MspRisultatoItem from "./MspRisultatoItem.vue";
import MspTestItem from "./MspTestItem.vue";
import FlagAttivita from "./flagAttivita.vue";

const NESSUNO = Object.freeze([]);

const ICONE_IMPEGNO = {
    "1": "msp-icon-impegno-1",
    "2": "msp-icon-impegno-2",
    "3": "msp-icon-impegno-3",
    "4": "msp-icon-impegno-4",
};

const raggruppaPerGiorno = function (lista, dataDi) {
    const out = {};
    lista.forEach((el)=>{
        const ymd = dataDi(el);
        if (!out[ymd]) out[ymd] = [];
        out[ymd].push(el);
    });
    return out;
};

export default {
    components: {
        MspAllenamentoItem,
        MspGaraItem,
        MspMisurazioni,
        MspRisultatoItem,
        MspTestItem,
        FlagAttivita,
    },

    props: {
        /** {monday, days, items, attivita, misurazioni, impegni} */
        settimana: { type: Object, required: true },
        parametri: { type: Array, default: ()=>[] },
        /** ymd di oggi */
        today: { type: String, required: true },
    },

    data: function () {
        return {
            nessuno: NESSUNO,
        };
    },

    computed: {
        perGiorno: function () {
            return {
                items: raggruppaPerGiorno(this.settimana.items, el=>el.data.data),
                attivita: raggruppaPerGiorno(this.settimana.attivita, el=>el.start_ymd),
                misurazioni: raggruppaPerGiorno(this.settimana.misurazioni, el=>el.data),
            };
        },
        isCurrentWeek: function () {
            return this.settimana.monday === _cal.getMonday(this.today);
        },
    },

    methods: {
        formatCalendarDay: function (ymd) {
            return _cal.formatCalendarDay(ymd);
        },

        impegnoDelGiorno: function (ymd) {
            return this.settimana.impegni.find(el=>{
                const fine = el.end_ymd || el.start_ymd;
                return el.start_ymd <= ymd && ymd <= fine;
            });
        },

        iconImpegno: function (ymd) {
            const impegno = this.impegnoDelGiorno(ymd);
            if (!impegno) return "";
            return ICONE_IMPEGNO[impegno.data.impegno_tipo_id];
        },

        openImpegno: function (ymd) {
            const impegno = this.impegnoDelGiorno(ymd);
            if (impegno) {
                this.$emit('open-modal', impegno);
            }
        },

        classDay: function (ymd) {
            const classes = ["day-"+_cal.getDate(ymd)];
            if (ymd === this.today) {
                classes.push("oggi");
            }
            if (this.isCurrentWeek) {
                classes.push("current-week");
            }
            if (_cal.getDate(ymd) === 1) {
                classes.push("first");
            }
            const impegno = this.impegnoDelGiorno(ymd);
            if (impegno) {
                classes.push("day-range");
                classes.push("day-range-"+impegno.type);
                classes.push("day-range-"+impegno.type+"-"+impegno.data.impegno_tipo_id);
            }
            return classes.join(" ");
        },
    },
};
</script>

<style lang="scss">
/* settimana lontana dalla vista (v. osservaSettimane in pages/calendario/Calendario.vue):
   hidden e non auto, che applicherebbe il contenimento anche alle settimane visibili */
.calendar-week--fuori {
    content-visibility: hidden;
}
</style>
